module.exports = __webpack_public_path__ + "assets/white_plus-d3a373.svg";